import React from 'react';
import { RocketIcon, CheckCircleIcon, FlameIcon } from 'lucide-react';
export function FinalCTA() {
  const handleCTAClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead');
    }
  };
  return <section className="w-full px-4 py-16 md:py-24 bg-dark" data-id="element-16">
      <div className="max-w-5xl mx-auto text-center" data-id="element-17">
        <div className="flex items-center justify-center gap-3 mb-8" data-id="element-18">
          <RocketIcon className="w-10 h-10 md:w-12 md:h-12 text-primary" data-id="element-19" />
          <h2 className="text-[32px] md:text-[48px] lg:text-[64px] font-bold font-poppins text-white tracking-tight uppercase" data-id="element-20">
            Este Es Tu Momento
          </h2>
        </div>
        <div className="space-y-6 mb-12 text-[18px] md:text-[22px] font-inter text-textGray leading-relaxed" data-id="element-21">
          <p data-id="element-22">Puedes seguir donde estás...</p>
          <p data-id="element-23">Esperando que algo cambie por sí solo...</p>
          <p className="text-[22px] md:text-[28px] font-bold font-poppins text-white" data-id="element-24">
            O puedes dar el paso que cambiará tu trayectoria.
          </p>
          <p className="text-primary font-bold text-[22px] md:text-[28px] uppercase tracking-wide" data-id="element-25">
            La decisión es completamente tuya.
          </p>
        </div>
        <div className="bg-lightBg p-8 md:p-16 rounded-3xl border-4 border-primary mb-10 shadow-2xl" data-id="element-26">
          <a href="https://closerdigital.net/F/NLeon1" target="_blank" rel="noopener noreferrer" onClick={handleCTAClick} className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 md:px-12 md:py-6 bg-gradient-to-r from-primary via-primary to-primaryHover text-white text-[16px] md:text-[20px] font-bold font-poppins rounded-2xl shadow-2xl hover:shadow-primary/70 transition-all duration-300 transform hover:scale-105 w-full md:w-auto uppercase tracking-wide mb-5 overflow-hidden max-w-2xl mx-auto" data-id="element-27">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-shimmer" data-id="element-28"></div>
            <FlameIcon className="w-6 h-6 md:w-7 md:h-7 group-hover:scale-110 transition-transform duration-300 flex-shrink-0 relative z-10" data-id="element-29" />
            <span className="relative z-10 leading-tight" data-id="element-30">
              Quiero Entrar al Entrenamiento Ahora
            </span>
          </a>
          <p className="text-[15px] md:text-[17px] font-inter text-textDark mb-5 leading-relaxed" data-id="element-31">
            Descubre si esta habilidad es para ti
          </p>
          <p className="text-[22px] md:text-[28px] font-bold font-poppins text-primary tracking-tight uppercase" data-id="element-32">
            Tu historia de transformación puede comenzar hoy
          </p>
          <div className="mt-10 grid md:grid-cols-3 gap-6" data-id="element-33">
            <div className="bg-dark p-6 rounded-2xl border-2 border-primary/30" data-id="element-34">
              <CheckCircleIcon className="w-10 h-10 text-primary mx-auto mb-4" data-id="element-35" />
              <p className="text-[17px] md:text-[19px] font-bold font-inter text-white uppercase" data-id="element-36">
                Mentoría Personal
              </p>
              <p className="text-[15px] font-inter text-textGray mt-2 leading-relaxed" data-id="element-37">
                Aprende directamente de quien ya lo logró
              </p>
            </div>
            <div className="bg-dark p-6 rounded-2xl border-2 border-primary/30" data-id="element-38">
              <CheckCircleIcon className="w-10 h-10 text-primary mx-auto mb-4" data-id="element-39" />
              <p className="text-[17px] md:text-[19px] font-bold font-inter text-white uppercase" data-id="element-40">
                Método Probado
              </p>
              <p className="text-[15px] font-inter text-textGray mt-2 leading-relaxed" data-id="element-41">
                Sistema paso a paso que funciona
              </p>
            </div>
            <div className="bg-dark p-6 rounded-2xl border-2 border-primary/30" data-id="element-42">
              <CheckCircleIcon className="w-10 h-10 text-primary mx-auto mb-4" data-id="element-43" />
              <p className="text-[17px] md:text-[19px] font-bold font-inter text-white uppercase" data-id="element-44">
                Comienza Ya
              </p>
              <p className="text-[15px] font-inter text-textGray mt-2 leading-relaxed" data-id="element-45">
                No esperes más para transformarte
              </p>
            </div>
          </div>
        </div>
        <div className="space-y-6 text-[16px] md:text-[18px] font-inter text-textGray" data-id="element-46">
          <p className="italic leading-relaxed" data-id="element-47">
            Mientras lees esto, otros ya están dando el paso...
          </p>
          <p className="text-[24px] md:text-[32px] font-bold font-poppins text-primary tracking-tight uppercase" data-id="element-48">
            ¿Serás tú el siguiente?
          </p>
        </div>
      </div>
    </section>;
}